'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:setBackAction');
}

var _invoke = require('../invoke');

/**
 * 修改后退操作
 *
 * 一旦设置该函数，用户点击后退时只会调用该函数而不会直接后退。
 * 可在函数内调用 `hbnb.webview.back` 方法进行后退
 *
 * TODO: 支持版本
 *
 * 支持版本
 * + iHotel/??
 *
 * @memberof webview
 * @static
 * @name setBackAction
 * @param {Function} cb 点击后退按钮时执行的函数
 * @return {Undefined}
 * @example
 *  hbnb.webview.setBackAction(function() {
 *      // do something
 *  });
 */
module.exports = function(cb) {
    if (process.env.NODE_ENV !== 'production') {
        debug('callback is %s', cb);
    }

    _invoke('webview', 'set_navbar_back', {
        callback: function() {
            cb();
            return false;
        }
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/set-back-action.js
// module id = 664
// module chunks = 0